<template>
  <div class="search-wrap">
    <div class="search-all" v-if="!showSearch && inputWidth > -1">
      <el-input
        placeholder="请输入内容"
        v-model="searchInput"
        clearable
        @clear="clearHandler"
        v-if="inputWidth > 100"
        :style="{ width: inputWidth + 'px' }"
        @input="wordLimit($event, 'searchInput', '', maxlength)"
        :maxlength="maxlength"
        ref="searchInput"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchClick"
        >搜索</el-button
        >
      </el-input>
    </div>

    <div class="user">
      <client-only>
        <el-badge
          v-if="nickname"
          class="badge-msg"
          :value="messageTotal"
          :max="99"
          :hidden="!messageTotal"
          v-czc="['导航栏', '点击按钮', '消息', 0, `nav-btn-message`]"
        >
          <div  class="userbtns" @click="messageTurn">
            <i
              class="iconfont btn btn-msg"
              :class="{ active: messageTotal }"
              :style="{marginTop: headportraitpath ? '5px' : ''}"
            >
              &#xe65f;
            </i>
          </div>
        </el-badge>

        <div class="userinfo">
          <template v-if="nickname">
            <el-dropdown class="header-dropdown" @command="commandHandler">
              <!-- <el-image class="user-header" :src="headportraitpath" fit="cover">
                            <div slot="error" class="image-slot">
                                <img class="user-header" src="@/assets/images/toux.png" alt="">
                            </div>
                        </el-image> -->
              <div
                class="headBox"
                :style="{ width: userDetail.vipinfo ? '47px' : 'auto' }"
              >
                <div
                  :class="
                    userVipInfo.isExpired && userVipInfo.viptype
                      ? 'vipHeader isExpired'
                      : 'vipHeader'
                  "
                >
                  <img
                    class="user-header"
                    v-if="headportraitpath"
                    :src="headportraitpath"
                    alt=""
                  />
                  <img class="user-header" v-else src="@/assets/images/toux.png" alt="" />
                  <img
                    v-if="userDetail.vipinfo && userDetail.vipinfo.viptype == 'super_vip'"
                    class="vipShow"
                    src="@/assets/images/vip/yearVIP.png"
                    alt=""
                  />
                  <img
                    v-if="userDetail.vipinfo && userDetail.vipinfo.viptype == 'year_vip'"
                    class="vipShow"
                    src="@/assets/images/vip/yearVIP.png"
                    alt=""
                  />
                  <img
                    v-if="userDetail.vipinfo && userDetail.vipinfo.viptype == 'day_vip'"
                    class="vipShow"
                    src="@/assets/images/vip/dayVIP.png"
                    alt=""
                  />
                </div>
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
                <div class="user-info">
                  <adduser-info
                    size="small"
                    :data="userDetail"
                    :isExpired="userVipInfo.isExpired"
                    type="user"
                  ></adduser-info>
                </div>
                <!-- 会员信息 -->
                <div
                  :class="
                    userVipInfo.isExpired && userVipInfo.viptype
                      ? 'vipInfo isExpired'
                      : 'vipInfo'
                  "
                >
                  <div class="left">
                    <div>{{ userVipInfo.vipTypeDesc || "开通会员" }}</div>
                    <div>会员月均低至{{ vipIntroduce.payamount }}元</div>
                  </div>
                  <div class="right">
                    <div @click="turnClick">{{ userVipInfo.btnText }}</div>
                  </div>
                  <img src="~assets/images/vip/vip.png" alt="" srcset="" />
                </div>
                <el-dropdown-item
                  v-for="(item, index) in dropdownArr"
                  :key="index"
                  :command="item.command"
                  :divided="item.divided"
                  v-czc="['导航栏', '点击按钮', '个人中心', 0, `nav-btn-${item.nodeid}`]"
                >
                  <i :class="item.icon"></i>

                  {{ item.text }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <template v-else>
            <div
              class="btn-group"
              v-czc="['导航栏', '点击按钮', '注册/登录', 0, `nav-btn-logonLogin`]"
            >
              <a class="btn-item" @click="login"> 注册/登录 </a>
            </div>
          </template>
        </div>
      </client-only>
    </div>
  </div>
</template>

<script>
import AdduserInfo from "../../adduser-info";
import { getDict, matchDict } from "@/assets/js/dict";
import { mapGetters, mapActions } from "vuex";
import utils from "@mixins/utils";
export default {
  mixins: [utils],
  components: {
    AdduserInfo,
  },
  data() {
    return {
      userVipInfo: "",
      pathname: "",
      vipTypeDictList: [],
      vipIntroduce: {
        payamount: 4,
      },
      dropdownArr: [
        {
          command: "user",
          icon: "el-icon-s-home",
          text: "个人中心",
          nodeid: "userCenter",
        },
        {
          command: "collect",
          icon: "el-icon-star-on",
          text: "我的收藏",
          nodeid: "nyCollect",
        },
        {
          command: "password",
          icon: "el-icon-edit",
          text: "修改密码",
          nodeid: "password",
        },
        {
          divided: true,
          command: "logout",
          icon: "el-icon-switch-button",
          text: "退出登录",
          nodeid: "logout",
        },
      ],
      searchInput: "",
      inputWidth: "600px",
      maxlength: 50,
    };
  },
  created() {
    getDict("vip_type").then((res) => {
      this.vipTypeDictList = res;
      this.getVipInfo();
    });
  },
  computed: {
    ...mapGetters({
      userInfo: "userinfo/getData",
      nickname: "userinfo/getNickname",
      headportraitpath: "userinfo/getHeadportraitpath",
      messageTotal: "message/getTotal",
    }),
    userDetail() {
      return {
        head: this.userInfo.headportraitpath,
        nickname: this.userInfo.nickname,
        marklist: this.userInfo.usertype === "expert" ? [{ description: "专家" }] : false,
        vipinfo: this.userInfo.bbsUserVip,
      };
    },
    showSearch() {
      // var route=this.$route
      return Boolean(this.$route.name && this.$route.name == "polymerize");
    },
  },
  watch: {
    $route() {
      this.pathname = window.location.href;
    },
    userInfo: {
      handler(e) {
        this.getVipInfo();
        this.queryMsgNum();
      },
      deep: true,
    },
  },
  methods: {
    login() {
      this.$store.commit("userinfo/upateLoginState", { show: true, callback: null });
    },
    commandHandler(command) {
      var switchObj = {
        user: () => {
          // this.goto('/user/setting');
          window.location.assign("/user/assets");
        },
        collect: () => {
          // this.goto('/user/collect');
          window.location.assign("/user/collect");
        },
        password: () => {
          window.location.assign("/user/password");
        },
        logout: () => {
          this.$store.dispatch("userinfo/logoutHandler");
        },
      };

      switchObj[command]();
    },
    ...mapActions({
      queryUserInfo: "userinfo/queryUserInfo",
      queryMsgNum: "message/queryMsgNum",
    }),

    //跳转我的消息
    messageTurn() {
      window.location.assign("/user/message");
    },

    //处理会员信息
    getVipInfo() {
      let btnText = "";
      let isExpired = false;
      let userVipInfo = this.userInfo.bbsUserVip;
      if (this.userInfo.vipIntroduce) {
        this.vipIntroduce = this.userInfo.vipIntroduce;
      } else {
        this.vipIntroduce.payamount = 4;
      }
      if (userVipInfo) {
        let expirationTime = userVipInfo.expiretime;
        userVipInfo.vipTypeDesc = matchDict(this.vipTypeDictList, userVipInfo.viptype);
        if (expirationTime) {
          userVipInfo.expirationTimeDesc = expirationTime.split(" ")[0];
        }
        if (userVipInfo.expiretime) {
          let expirationTime = userVipInfo.expiretime;
          isExpired = new Date(expirationTime).getTime() < new Date().getTime();
          btnText = isExpired ? "立即恢复" : "会员详情";
        }
      } else {
        btnText = "立即开通";
        userVipInfo = {};
      }

      this.userVipInfo = {
        ...userVipInfo,
        btnText,
        isExpired,
      };
    },
    //跳转会员
    turnClick() {
      if (this.$route.path != "/user/assets/vip") {
        window.location.href = `/user/assets/vip?redirectUrl=${encodeURIComponent(
          this.pathname
        )}`;
      }
    },
    searchClick() {
      var content = this.searchInput;
      if (content != "" && /^ *$/.test(content)) {
        //判断输入的都是空格,不允许发送
        this.searchInput = "";
        this.$message.info("请输入内容");
        return;
      }
      var url = this.searchInput
        ? "/polymerize?title=" + this.searchInput
        : "/polymerize";
      window.location.assign(url);
    },
    clearHandler() {
      this.searchInput = "";
    },
    handleResize() {
      setTimeout(() => {
        var aWidth = document.body.offsetWidth;
        if (aWidth > 1600) {
          this.inputWidth = 300;
        } else if (aWidth > 1500) {
          this.inputWidth = 200;
        } else if (aWidth > 1400) {
          this.inputWidth = 100;
        } else if (aWidth > 1370) {
          this.inputWidth = 60;
        } else {
          this.inputWidth = -1;
        }
      });
    },
  },
  mounted: function () {
    this.pathname = window.location.href;
    this.queryUserInfo();
    this.queryMsgNum();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";
.search-wrap{
  display:flex;
  align-items: center;
}

.user {
  display: flex;
  align-items: center;

  &:after {
    content: "";
    clear: both;
  }

  .badge-msg {
    ::v-deep {
      .is-fixed {
        top: -4px;
      }

      margin: 0 20px 0 15px;
    }
  }

  .userbtns {
    float: left;
    color: #999999;
    margin-top: -4px;

    .btn {
      cursor: pointer;
      font-size: 20px;
      display: inline-block;
      width: 20px;
      height: 20px;

      &.active {
        color: $primaryColor;
      }
    }
  }

  .btn-group {
    overflow: hidden;
    margin-left: 38px;

    .btn-item {
      display: block;
      float: left;
      line-height: 1em;
      color: #333333;
      position: relative;
      transition: all 0.3s;

      &:hover {
        color: $primaryColor;
      }
    }
  }

  .header-dropdown {
    .user-header {
      width: 30px;
      height: 30px;
      background: $primaryColor1;
      border-radius: 50%;
      transition: all 0.3s;
      vertical-align: middle;

      &:hover {
        box-shadow: -3px 3px 3px #dcdfe6;
      }
    }
  }
}

.user-dropdown-menu {
  width: 240px;

  .user-info {
    padding: 0 20px;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .el-dropdown-menu__item {
    text-align: center;
  }
}
.vipInfo {
  margin: 20px 0;
  padding: 10px;
  background-color: rgba(252, 240, 220, 1);
  height: 65px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  position: relative;

  img {
    position: absolute;
    width: 50px;
    bottom: 0;
    right: 0;
    z-index: 1;
  }
}

.vipInfo.isExpired {
  background: rgba(215, 215, 215, 1);
}

.vipInfo .right {
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 2;
}

.vipInfo .left div:first-child {
  font-size: 14px;
  color: #765029;
}

.vipInfo .left div:last-child {
  margin-top: 5px;
  font-size: 13px;
  color: #7c6d63;
}

.vipInfo .right div {
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  background-color: rgba(241, 193, 113, 1);
  border-radius: 12px;
  padding: 0 10px;
  color: white;
  cursor: pointer;
}
.vipHeader {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 2px solid rgb(250, 232, 208);
  .vipShow {
    height: 20px;
    position: absolute;
    right: -14px;
    top: -7px;
    width: 20px;
    z-index: 10;
  }
}
.vipHeader.isExpired {
  border-color: #ccc !important;
  .vipShow {
    filter: grayscale(100%);
  }
}

.search-all {
  width: fit-content;
  ::v-deep .el-input-group--append .el-input__inner {
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
  }
  ::v-deep .el-input-group__append {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }
}
</style>
